import { PAGE_PATHS } from './routes.types';

export const INTERNAL_ROLES = {
  RND_ADMIN: 'RND_ADMIN',
  SYS_ADMIN: 'SYS_ADMIN',
  RISK360_RND_ADMIN: 'RISK360_RND_ADMIN',
  RISK360_SUPPORT_ADMIN: 'RISK360_SUPPORT_ADMIN',
};

// TODO: cleanup after permissions is fully migrated
export const ROLES = {
  RND_ADMIN: 7,
  ADMIN: 5,
  EDITOR: 4,
  VIEWER: 3,
  SIEM_USER: 2,
  PRE_POV: 1,
  SYS_ADMIN: 18,
};

export const getRoleNameByValue = value => Object.keys(ROLES).find(key => ROLES[key] === value);

export const OLD_PREDEFINED_ROLE_NAMES = {
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER',
  SIEM_USER: 'SIEM_USER',
};

export const NEW_PREDEFINED_ROLE_NAMES = { DEFAULT: 'DEFAULT', RND_ADMIN: 'RND_ADMIN', ADMIN: 'ADMIN' };
export const PREDEFINED_ROLE_NAMES = { ...OLD_PREDEFINED_ROLE_NAMES, ...NEW_PREDEFINED_ROLE_NAMES };
export const FeatureFlags = {
  ShowAssetsDashboardOverview: 'assets-overview-dashboard', // https://jira.corp.zscaler.com/browse/AVA-13728
  createTicketFromAlerts: 'create-ticket-from-alerts', // https://jira.corp.zscaler.com/browse/AVA-13733
  ShowRoiDashboard: 'show-roi-dashboard', // https://jira.corp.zscaler.com/browse/AVA-13734
  ShowServerErrorInToast: 'show-server-error-in-toast', // https://jira.corp.zscaler.com/browse/AVA-13736
  disableCacheQueryClient: 'disable-cache-query-client', // https://jira.corp.zscaler.com/browse/AVA-13739
  ShowDataLakeMonths: 'ShowDataLakeMonths', // https://jira.corp.zscaler.com/browse/AVA-13742
  ReportsHistorical: 'enable-reports-historical', // https://jira.corp.zscaler.com/browse/AVA-13745
  MeasurementsPage: 'measurements-page', // https://jira.corp.zscaler.com/browse/AVA-13748
  EnableDataRetentionDefaultRulesCreation: `enable-data-retention-default-rules-creation`, // https://jira.corp.zscaler.com/browse/AVA-13077
  BatchAggregation: 'batch-aggregation', // https://jira.corp.zscaler.com/browse/AVA-13782
  ShowDrillDown: 'show-drill-down', // https://jira.corp.zscaler.com/browse/AVA-13783
  HistoricalAnalytics: 'historical-analytics', // https://jira.corp.zscaler.com/browse/AVA-13784
  InvestigateEntity: 'investigate-entity', // https://jira.corp.zscaler.com/browse/AVA-13786
  accountUsagePage: 'account-usage-page', // https://jira.corp.zscaler.com/browse/AVA-13789
  KeepSlaWithoutFormatting: 'keep-sla-without-formatting', // https://jira.corp.zscaler.com/browse/AVA-13791
  QueryObjectEditor: 'widget-query-object-editor', // https://jira.corp.zscaler.com/browse/AVA-13794
  NewRolesForUserMgmPage: 'new-roles-for-user-mgm', // https://jira.corp.zscaler.com/browse/AVA-13795
  ShowAliasPage: 'show-alias-page', // https://jira.corp.zscaler.com/browse/AVA-13796
  ShowMeasurementsPage: 'show-measurements-page', // https://jira.corp.zscaler.com/browse/AVA-13797
  NewLogsScreen: 'new-logs-screen', // https://jira.corp.zscaler.com/browse/AVA-13799
  OneAuthUI: 'one-auth-ui', // https://jira.corp.zscaler.com/browse/AVA-13800
  TileWidgetSupportsText: 'tile-widget-supports-text', // https://jira.corp.zscaler.com/browse/AVA-13801
  OutegrationQueryObjectAttachment: 'attachment-as-query-object-for-outegrations', // https://jira.corp.zscaler.com/browse/AVA-13802
  EnableZscalerConfigEdit: 'enable-zscaler-config-edit', // https://jira.corp.zscaler.com/browse/AVA-13803
  TopFields: 'top-fields', // https://jira.corp.zscaler.com/browse/AVA-13809
  NewFieldsToolbar: 'new-fields-toolbar', // https://jira.corp.zscaler.com/browse/AVA-13812
  ClickthroughRelatedFields: 'clickthrough-related-field', // https://jira.corp.zscaler.com/browse/AVA-11915
  PopulatedFields: 'populated-fields', // https://jira.corp.zscaler.com/browse/AVA-13877
  PermissionsForUpdateDefaultMapping: 'permission-to-update-default-mapping', // https://jira.corp.zscaler.com/browse/AVA-11038
  TemporalWorkflowMetadata: 'temporal-workflow-metadata', // https://jira.corp.zscaler.com/browse/AVA-14308
  SourceValuesUIConfig: 'ingress-values-ui-config', // https://jira.corp.zscaler.com/browse/AVA-14187
  SourceIconsCustomDashboards: 'source-icons-custom-dashboards', // https://jira.corp.zscaler.com/browse/AVA-14967
  CrossAppChangePopUp: 'cross-app-change-popup', // https://jira.corp.zscaler.com/browse/AVA-15597
  PivotTable: 'pivot-table', // https://jira.corp.zscaler.com/browse/AVA-15431,
  AvTableV2: 'table-v2', // https://jira.corp.zscaler.com/browse/AVA-16312
  SubscriptionToDsiFailures: 'subscription-to-dsi-failures', // https://jira.corp.zscaler.com/browse/AVA-16355
  NewChartTooltip: 'new-chart-tooltip', // https://jira.corp.zscaler.com/browse/AVA-14238
  BridgeMapping: 'bridge-auto-mapping', // https://jira.corp.zscaler.com/browse/AVA-17029
  ExplodeMapping: 'explode-mapping', // https://jira.corp.zscaler.com/browse/AVA-19188
  MappingAgent: 'mapping-genie', // https://jira.corp.zscaler.com/browse/AVA-17304
  DateDimBucket: 'date-dim-bucket', // https://jira.corp.zscaler.com/browse/AVA-17275
  QueryAdmin: 'query-admins', // https://jira.corp.zscaler.com/browse/AVA-17013
  AllowAdminsToViewAllDashboardsOption: 'allow-admin-to-view-all-dashboards-option', // https://jira.corp.zscaler.com/browse/AVA-16973
  ShowFactorsPage: 'show-factors-page', // https://jira.corp.zscaler.com/browse/AVA-17656
  ScannersActivation: 'activation-scanners', // https://jira.corp.zscaler.com/browse/AVA-16739
  ShowTimezoneSetting: 'show-timezone-setting', // https://jira.corp.zscaler.com/browse/AVA-17780
  NewAccountSettingsFields: 'new-account-settings-fields', // https://jira.corp.zscaler.com/browse/AVA-17542
  RemediationCopilot: 'remediation-copilot', // https://jira.corp.zscaler.com/browse/AVA-18033,
  salesforceSsoAvailable: 'salesforce-sso-available', // https://jira.corp.zscaler.com/browse/AVA-18534,
  FailureNotificationWorkflow: 'use-failure-notification-wf', // https://jira.corp.zscaler.com/browse/AVA-18626
  DataHygienePolicy: 'data-hygiene-policy', // https://jira.corp.zscaler.com/browse/AVA-18570
  DataHygienePolicyConflictingValues: 'data-hygiene-policy-conflicting-values', // https://jira.corp.zscaler.com/browse/AVA-18894
  HistoricalClickthrough: 'historical-clickthrough', // https://jira.corp.zscaler.com/browse/AVA-18686
  ClickthroughRootProj: 'clickthrough-root-proj', // https://jira.corp.zscaler.com/browse/AVA-18900
  FindingsViewTicketAndFindingSLA: 'findings-view-ticket-and-finding-sla', // https://jira.corp.zscaler.com/browse/AVA-18973
  WidgetShowDataLabels: 'widget-show-data-labels', // https://jira.corp.zscaler.com/browse/AVA-18736
  UnificationRuleDefaultField: 'unification-rule-default-field', // https://jira.corp.zscaler.com/browse/AVA-19058
  DefaultMinPointSizeBarChart: 'default-min-point-size-bar-chart', // https://jira.corp.zscaler.com/browse/AVA-10430
  SubscriptionToOutegrationFailures: 'subscription-to-outegration-failures', // https://jira.corp.zscaler.com/browse/AVA-18626
  CDOverSelection: 'cd-over-selection', // https://jira.corp.zscaler.com/browse/AVA-18863
  AuditLogsExport: 'audit-logs-export', // https://jira.corp.zscaler.com/browse/AVA-17739
  breadcrumbs: 'breadcrumbs', // https://jira.corp.zscaler.com/browse/AVA-17825
  NewSeverityAndSLA: 'new-severity-and-sla', // https://jira.corp.zscaler.com/browse/AVA-19132
  WidgetHistoricalFilterMode: 'widget-historical-filter-mode', // https://jira.corp.zscaler.com/browse/AVA-18691
  AffectedEntitiesAging: 'affected-entities-aging', // https://jira.corp.zscaler.com/browse/AVA-19666
  AllowCustomSchedulingForDsi: 'allow-custom-scheduling-for-dsi', // https://jira.corp.zscaler.com/browse/AVA-19799
  IncidentRuleAttackPath: 'inciident-rules-attack-path', // https://jira.corp.zscaler.com/browse/AVA-194
  IncludeFunctionsInMergeEntity: 'include-functions-in-entity-merge', // https://jira.corp.zscaler.com/browse/AVA-20051
  ResourceInstancePermissions: 'resource-instance-permissions', // https://jira.corp.zscaler.com/browse/AVA-20019
  ClickthroughViews: 'clickthrough-views', // https://jira.corp.zscaler.com/browse/AVA-19708
  LogsPageBetaMigration: 'logs-page-beta-migration', // https://jira.corp.zscaler.com/browse/AVA-19516
  ScheduleExportPermissions: 'schedule-export-permissions', // https://jira.corp.zscaler.com/browse/AVA-19589
  FormattingRulesDims: 'formatting-rules-dims', // https://jira.corp.zscaler.com/browse/AVA-20295
  ShowThreatDashboard: 'threat-dashboard', // https://jira.corp.zscaler.com/browse/AVA-20062
  isTicketPanelDateFieldLocalTZ: 'ticket-panel-local-tz-date-fields', // https://jira.corp.zscaler.com/browse/AVA-20630
  ViolationTicketLifecycle: 'violation-ticket-lifecycle', // https://jira.corp.zscaler.com/browse/AVA-20624
  MappingTestScript: 'test-mapping-genie', // https://jira.corp.zscaler.com/browse/AVA-20692
  LifecycleEndpointV2: 'lifecycle-endpoints-v2', // https://jira.corp.zscaler.com/browse/AVA-21173
  ShowNewIncidentDrilldown: 'incident-drilldown', // https://jira.corp.zscaler.com/browse/AVA-20770
  DisableMetricsCT: 'disable-metrics-ct', // https://jira.corp.zscaler.com/browse/AVA-21412
  CustomDashboardsFilterListTab: 'custom-dashboards-filter-list-tab', // https://jira.corp.zscaler.com/browse/AVA-21769
  ShowAgentsCopilot: 'show-agents-copilot', // https://jira.corp.zscaler.com/browse/AVA-22072
  RowDedupCT: 'row-dedup-ct', // https://jira.corp.zscaler.com/browse/AVA-21951
  ShowAssetDiscoveryPage: 'show-asset-discovery-page', // https://jira.corp.zscaler.com/browse/AVA-22085
} as const;

export type FeatureFlagValue = (typeof FeatureFlags)[keyof typeof FeatureFlags];

export const PathFeatureFlag = {
  [PAGE_PATHS.ROI]: FeatureFlags.ShowRoiDashboard,
  [PAGE_PATHS.MEASUREMENTS]: FeatureFlags.MeasurementsPage,
  [PAGE_PATHS.DATA_PURGE]: FeatureFlags.EnableDataRetentionDefaultRulesCreation,
  [PAGE_PATHS.ACCOUNT_USAGE]: FeatureFlags.accountUsagePage,
  [PAGE_PATHS.AUTHENTICATION_SOURCES]: FeatureFlags.OneAuthUI,
  [PAGE_PATHS.SCANNERS_ACTIVATION]: FeatureFlags.ScannersActivation,
  [PAGE_PATHS.FACTOR]: FeatureFlags.ShowFactorsPage,
  [PAGE_PATHS.DISCOVERY_SETTINGS]: FeatureFlags.ShowAssetDiscoveryPage,
};

export enum Permission {
  READ = 'READ',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  AUDIT = 'AUDIT',
}

export enum PermissionEntitiesNames {
  // Platform
  MODEL = 'MODEL',
  SOURCE = 'SOURCE',
  SOURCE_MAPPING = 'SOURCE_MAPPING',
  WORKFLOW_SCRIPT = 'WORKFLOW_SCRIPT',
  USER = 'USER',
  ACCOUNT = 'ACCOUNT',
  ACCOUNT_SAVED_VIEWS = 'ACCOUNT_SAVED_VIEWS',
  VIEWS = 'VIEWS',
  ROLE = 'ROLE',
  INTEGRATION = 'INTEGRATION',
  ALIAS = 'ALIAS',
  ZCONFIG = 'ZCONFIG',
  AUTHENTICATION = 'AUTHENTICATION',
  MEASUREMENT = 'MEASUREMENT',

  // Explore
  SEARCH = 'SEARCH',
  REPORT = 'REPORT',

  // Multiple Apps
  ANALYTICS = 'ANALYTICS',
  EXCEPTION = 'EXCEPTION',

  // Entity
  OPT = 'OPT',
  SETTINGS = 'SETTINGS',
  INT = 'INT',
  QUERY_RUNNER = 'QUERY_RUNNER',

  // Detection App
  RULE = 'RULE',
  GLOBAL_SCRIPT = 'GLOBAL_SCRIPT',
  LOOKUP_TABLE = 'LOOKUP_TABLE',

  // Risk 360 App
  EXE_RULE = 'EXE_RULE',
  BUILTIN_EXE_RULE = 'BUILTIN_EXE_RULE',

  // Backoffice
  BACKOFFICE = 'BACKOFFICE',
}

export enum PermissionAppName {
  PLATFORM = 'PLATFORM',
  EXPLORE = 'EXPLORE',
  ENTITY = 'ENTITY',
  VULNERABILITIES = 'VULNERABILITIES',
  DETECTIONS = 'DETECTIONS',
  INCIDENTS = 'INCIDENTS',
  ASSETS = 'ASSETS',
  RISK360 = 'RISK360',
  THREATS = 'THREATS',
  IDENTITIES = 'IDENTITIES',
}

export enum PermissionModelEntityName {
  TICKET = 'TICKET',
  FINDING = 'FINDING',
  ASSET = 'ASSET',
  INCIDENT = 'INCIDENT',
  ALERT = 'ALERT',
  FACTOR = 'FACTOR',
  POLICYVIOLATION = 'POLICYVIOLATION',
  VIOLATION_TICKET = 'VIOLATIONTICKET',
  EXCEPTION = 'EXCEPTION',
  TENANT = 'TENANT',
  IDENTITY_FINDING = 'IDENTITYFINDING',
  IDENTITY = 'IDENTITY',
  USER = 'USER',
}

export type PermissionCategoriesNames = PermissionAppName | PermissionModelEntityName;

export type PermissionForRoute =
  | {
      category?: PermissionCategoriesNames;
      permissionEntity: PermissionEntitiesNames;
    }
  | { requiredRole: keyof typeof PREDEFINED_ROLE_NAMES };
